import React from 'react';
import PropTypes from 'prop-types';

import RefinementsHeader from './refinements-header';
import RefinementsCurrent from './refinements-current';
import RefinementList from './refinements-list';
import RangeSlider from './range-slider';

const Refinements = ({ isBrandRefined }) => (
  <section>
    <RefinementsHeader isBrandRefined={isBrandRefined} />

    <RefinementsCurrent isBrandRefined={isBrandRefined} />

    <RefinementList attribute="product_type" />
    <RefinementList attribute="gender" />
    <RefinementList attribute="variants.age_range" />
    <RefinementList attribute="variants.shoe_sizes" />
    <RefinementList attribute="variants.clothing_sizes" />
    { !isBrandRefined && <RefinementList attribute="brand" searchable /> }
    <RefinementList attribute="color" />
    <RangeSlider attribute="variants.maisonette_sale" />
  </section>
);

Refinements.defaultProps = {
  isBrandRefined: false
};

Refinements.propTypes = {
  isBrandRefined: PropTypes.bool
};

export default Refinements;
